export const fieldsName = {
  username: 'username',
  password: 'password',
};
